module.exports = __webpack_public_path__ + "static/media/2.b59f2563.jpg";